import Modal, { ModalActionData } from '@superfunnel/ui-core/Modal';
import { useEffect, useMemo, useState } from 'react';
import { CodeEditorTextArea } from '../components/FormFields/CodeEditor/CodeEditorTextArea';

interface Props {
  code?: string;
  onSave: (code: string) => void;
  open: boolean;
  onClose: () => void;
}

export default function CodeEditorModal({
  code,
  open,
  onClose,
  onSave,
}: Props) {
  const [value, setValue] = useState(code ?? '');

  useEffect(() => {
    setValue(code ?? '');
  }, [code]);

  const actions: ModalActionData[] = useMemo(
    () => [
      {
        title: 'Cancel',
        type: 'secondary',
        onClick: () => onClose(),
      },
      { type: 'spacer' },
      {
        title: 'Save',
        type: 'primary',
        onClick: () => {
          onSave(value);
          onClose();
        },
      },
    ],
    [onClose, onSave, value],
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      actions={actions}
      width="6xl"
      actionsAlignment="start"
    >
      <div
        className="mt-0 flex flex-col gap-4"
        style={{ height: '60vh', maxHeight: '100%' }}
      >
        <CodeEditorTextArea
          value={value ?? ''}
          onChange={(code) => setValue(code)}
          className="h-full"
        />
      </div>
    </Modal>
  );
}
